import { ApplicantReferee } from "@prisma/client";
import axios from "axios";

import { ApplicantRefereeFull } from "@/lib/prisma";

export const getApplicantReferees = async (
  applicationId: string
): Promise<ApplicantReferee[]> => {
  return await axios
    .get<ApplicantReferee[]>(
      `${process.env.NEXT_PUBLIC_API_URL}/application/${applicationId}/referee`
    )
    .then((res) => res.data);
};

export const getApplicantRefereesWithScoring = async (
  applicationId: string
): Promise<ApplicantRefereeFull[]> => {
  return await axios
    .get<ApplicantRefereeFull[]>(
      `${process.env.NEXT_PUBLIC_API_URL}/application/${applicationId}/referee/with-scoring`
    )
    .then((res) => res.data);
};

export const saveApplicantReferee = async (
  applicationId: string,
  data: ApplicantRefereeFull
): Promise<ApplicantRefereeFull> => {
  return await axios
    .post(
      `${process.env.NEXT_PUBLIC_API_URL}/application/${applicationId}/referee`,
      data
    )
    .then((res) => res.data);
};

export const setReviewedReferee = async (
  applicationId: string
): Promise<ApplicantRefereeFull> => {
  return await axios
    .post(
      `${process.env.NEXT_PUBLIC_API_URL}/application/${applicationId}/referee/set-reviewed`
    )
    .then((res) => res.data);
};

export const deleteApplicantReferee = async (
  applicationId: string,
  applicantRefereeId: string
): Promise<void> => {
  return await axios
    .delete(
      `${process.env.NEXT_PUBLIC_API_URL}/application/${applicationId}/referee/${applicantRefereeId}`
    )
    .then((res) => res.data);
};
